import "core-js/modules/es.array.concat";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pop from '@/mixin/pop';
import { loadScript } from '@tencent/vft-utils';
import atom from '@tencent/vft-atom';
import env from '@tencent/vft-common/env';
import MagicService from '../../../service/magic';
import { mapState, mapActions } from 'vuex';
var _window$setting = window.setting,
    _window$setting$$ = _window$setting.支付面板.引导文案,
    超下限 = _window$setting$$.超下限,
    超上限 = _window$setting$$.超上限,
    _window$setting$ = _window$setting.魔方配置,
    商品ID = _window$setting$.商品ID,
    模块ID = _window$setting$.模块ID,
    活动ID = _window$setting$.活动ID;
var loadScriptPromise = null;
export default {
  mixins: [pop],
  data: function data() {
    return {
      selectSelf: true,
      selectOther: false,
      otherNum: 1
    };
  },
  props: {
    // 明星ID参数
    params: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.selectSelf = !this.hasTicket;
        this.selectOther = this.hasTicket;
        this.otherNum = 1; // AB Test 数据上报

        this.$report.expose(this.abTestParams);
      }

      if (val && !window.VftSingleCashier) {
        loadScriptPromise = loadScript('https://vm.gtimg.cn/tencentvideo/script/film/lib/VftSingleCashier.umd.min.js');
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState(['abTestInfo'])), {}, {
    showAType: function showAType() {
      var result = this.abTestInfo.result;
      return result !== 'B';
    },
    maxCount: function maxCount() {
      return 200;
    },
    // 总数量，分为A、B两种方案
    totalNum: function totalNum() {
      if (this.showAType) {
        return (this.isRealBuySeal ? 1 : 0) + (this.selectOther ? this.otherNum : 0);
      }

      return this.otherNum;
    },
    price: function price() {
      return this.vipService.isVip ? 12 : 24;
    },
    orgPrice: function orgPrice() {
      return 24 * this.totalNum;
    },
    cheapPrice: function cheapPrice() {
      return this.totalPrice - this.totalNum * 12;
    },
    // 是否自己购买，用户没有票并且有选中自己（B方案自动选中用户自己）
    isRealBuySeal: function isRealBuySeal() {
      return !this.hasTicket && this.selectSelf;
    },
    // 总价
    totalPrice: function totalPrice() {
      return +Number(this.price * this.totalNum).toFixed(2);
    },
    // pay_type中1为1自己购买  2表示为他人购买  3表示为自己和他人购买
    payType: function payType() {
      // A模式计算 payType 方式
      if (this.showAType) return this.isRealBuySeal && this.selectOther ? 3 : this.selectOther ? 2 : 1; // B模式计算 payType 方式

      var own = this.hasTicket ? 0 : 1;
      var other = this.otherNum - own;
      return own > 0 && other > 0 ? 3 : other === 0 ? 1 : 2;
    },
    buyParams: function buyParams() {
      var params = {
        appid: '1005',
        // 必填
        items: 商品ID,
        // 必填
        remark: "act_id=".concat(活动ID, "&mod_id=").concat(模块ID, "&pay_type=").concat(this.payType, "&buy_count=").concat(this.totalNum),
        hlwofferid: this.setting.支付面板.hlwofferid,
        publicParam: {
          report_servtype: '4'
        }
      };
      return params;
    },
    // 支付面板 abTest
    abTestParams: function abTestParams() {
      var GrayPolicyId = this.abTestInfo.GrayPolicyId;
      var params = Object.assign({}, this.reportData.支付面板.ABTest, {
        im_experiment_id: GrayPolicyId
      });
      return params;
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapActions(['getMyProps'])), {}, {
    checkNum: function checkNum(e) {
      var val = +e.target.value;
      if (!val) this.refreshNum(1);
    },
    changeNum: function changeNum(e) {
      var val = +e.target.value;

      if (val) {
        this.refreshNum(val);
      }
    },
    refreshNum: function refreshNum(num) {
      var maxCount = this.maxCount;

      if (num > maxCount) {
        this.toast(超上限.replace(/\${maxCount}/, maxCount));
        this.otherNum = maxCount;
      } else if (num < 1) {
        this.toast(超下限);
        this.otherNum = 1;
      } else {
        this.otherNum = num;
      }

      this.selectOther = true;
    },
    toggleItem: function toggleItem(type) {
      if (type === 'self') {
        this.selectSelf = !this.selectSelf;
        return;
      }

      this.selectOther = !this.selectOther;
    },
    buy: function buy() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var self;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // AB test 数据上报
                _this.$report.click(_this.abTestParams);

                console.log(_this.buyParams);

                if (!(_this.totalNum < 1)) {
                  _context.next = 5;
                  break;
                }

                _this.toast('请先选择购买数量');

                return _context.abrupt("return");

              case 5:
                self = _this;
                _context.next = 8;
                return loadScriptPromise;

              case 8:
                // todo 拉起支付组件
                window.VftSingleCashier.buy(_objectSpread(_objectSpread({}, _this.buyParams), {}, {
                  onSuccess: function onSuccess(res) {
                    console.log('pay succ, orderid:', res.order_id);
                    self.paySuccCb(res);
                  },
                  onCancel: function onCancel() {
                    console.log('user canceled...');
                  }
                }));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 支付成功回调函数
    // eslint-disable-next-line camelcase
    paySuccCb: function paySuccCb(_ref) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var order_id, token, res, payType, totalNum, buyParams, _ref2, id;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                order_id = _ref.order_id;
                token = null;

                if (!_this2.selectOther) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return MagicService.getShareToken({
                  order_id: order_id
                }).catch(function (e) {
                  var code = e.code;

                  if (code === -1019) {
                    _this2.toast('您的套票已经被抢光了');
                  } else {
                    _this2.toast("\u670D\u52A1\u5668\u5F00\u5C0F\u5DEE\u4E86[".concat(e.code, "]"));
                  } // return Promise.reject(e)

                });

              case 5:
                res = _context2.sent;

                if (res && res.ret === 0) {
                  token = res.token;
                }

              case 7:
                // 关闭弹窗
                _this2.close(); // 执行刷新票操作


                _this2.eventBus.$emit('refreshTicketInfo');

                _this2.eventBus.$emit('bookAct');

                if (env.isApp) {
                  // webview支付成功
                  atom.invoke('publishMsgToAllWebView', {
                    messageType: 'event',
                    messageName: 'vft-buy-page_onPayVideoSucc'
                  });
                  atom.invoke('onVideoPayFinish', {
                    success: 1
                  });
                } // 刷新我的魂力值


                _context2.next = 13;
                return _this2.getMyProps();

              case 13:
                // 购票参数
                payType = _this2.payType, totalNum = _this2.totalNum;
                buyParams = {
                  mode: payType === 1 ? 'buy' : 'zs',
                  label: payType === 1 ? '已购买' : "\u5DF2".concat(payType === 2 ? '送出' : '支持').concat(totalNum, "\u4EFD"),
                  token: token,
                  count: payType === 2 ? totalNum : totalNum - 1
                };
                _ref2 = _this2.params || {}, id = _ref2.id;

                _this2.eventBus.$emit(id ? 'showPowerPop' : 'showSelectPop', {
                  id: id,
                  ticketNum: _this2.totalNum,
                  buyParams: buyParams
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  })
};